import styles from './style.module.scss';
import { IoCloseSharp } from "react-icons/io5";
import { FaCheck, FaLifeRing, FaQuestionCircle } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { setTourSteps } from 'store/tour-slice';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { $t } from 'helpers/translator';

const GettingStartedContent = ({ onClose, onShowAgainStateChange, showAgainValue, cards }) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [ steps, setSteps ] = useState([]);
    const [ dontShowAgain, setDontShowAgain ] = useState(showAgainValue);

    const startTour = (steps, url) => {
        dispatch(setTourSteps(steps, url)).then(() => {
            history.push(url);
        })
    }

    useEffect(() => {
        setSteps(cards.map(card => {
            return {
                ...card,
                onClick: () => {
                    if (card.tour) {
                        if (Array.isArray(card.tour.steps)) {
                            startTour(card.tour.steps, card.tour.url)
                        }
                    }

                    if (card.url) {
                        history.push(card.url)
                    }
                }
            }
        }))
    }, [ cards ])

    useEffect(() => {
        onShowAgainStateChange(dontShowAgain)
    }, [ dontShowAgain ])

    const reportOnClose = (closedByTourClick) => {
        if (onClose) {
            onClose({
                dontShowAgain: dontShowAgain,
                closedByTourClick: closedByTourClick
            })
        }
    }

    return (
        <div className={ `${styles[ 'container' ]}` }>
            <div className={ styles[ 'header' ] }>
                <div>
                    <h1>{ $t('global.gettingStarted.title') }</h1>
                    <p>
                        { $t('global.gettingStarted.description') }
                    </p>
                </div>
                <button className='close' onClick={ (e) => {
                    reportOnClose(false)
                } }>
                    <IoCloseSharp />
                </button>
            </div>

            <section className={ styles[ 'grid' ] }>
                <div className={ styles[ 'content' ] }>
                    { steps.map((step, index) => (
                        <div key={ index } className={ styles[ 'step' ] }>
                            <div className={ styles[ 'step-icon' ] }>
                                <img width={ 64 } src={ step.image } alt={ step.title } />
                            </div>
                            <div className={ styles[ 'step-content' ] }>
                                <h3>{ step.title }</h3>
                                <p>
                                    { step.description }
                                </p>
                                { step.cta && <button onClick={ (e) => {
                                    reportOnClose(true)
                                    step.onClick(e);
                                } } className={ styles[ 'cta' ] }>{ step.cta }</button> }
                            </div>
                        </div>
                    )) }

                </div>


                <section className={ styles[ 'help' ] }>
                    <FaQuestionCircle />
                    <div>
                        <h3>
                            { $t('global.gettingStarted.help.title') }
                        </h3>
                        <p>
                            { $t('global.gettingStarted.help.description.partOne') }
                            <Link to="/help"> { $t('global.gettingStarted.help.description.link') } </Link>
                            { $t('global.gettingStarted.help.description.partTwo') }
                        </p>
                    </div>

                </section>
            </section>

            <div className={ styles[ 'footer' ] }>
                <div className={ styles[ 'checkbox' ] }>
                    <input type="checkbox" defaultChecked={ dontShowAgain } onChange={ (e) => {
                        setDontShowAgain(e.target.checked)
                    } } id="checkbox" />
                    <label htmlFor="checkbox">{ $t('global.gettingStarted.showAgain') }</label>
                </div>
                <button onClick={ (e) => {
                    reportOnClose(false)
                } } className={ styles[ 'cta' ] }>
                    <FaCheck /> { $t('global.gettingStarted.confirm') }
                </button>
            </div>
        </div>
    )
}

export default GettingStartedContent;